<template>
    <div role="tabcard" class="tab-pane" id="work-orders">
        <work-orders-list :role="role" :user="user" :project="project"></work-orders-list>
    </div>
</template>

<script>
    export default {
        props: ['role', 'project', 'user'],

        created: function() {

        },

        mounted: function() {

        },

        data: function() {
            return {
            };
        },

        computed: {
            
        },

        methods: {
           
        }
    }
</script>
